import {
    Component,
    computed,
    inject,
    Input,
    OnInit,
    signal
} from "@angular/core";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { CompanyEntity } from "@arch/domain/entity";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { DeviceService } from "@app/shared/services/device.service";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import { DatePeriodService } from "@shared/services/date-period.service";
import { ActivatedRoute } from "@angular/router";
import { environment } from "@environments/environment";

@Component({
    selector: "app-report-header",
    imports: [SharedDsnModule, SharedMaterialModule],
    templateUrl: "./report-header.component.html",
    styleUrl: "./report-header.component.scss"
})
export class ReportHeaderComponent implements OnInit {
    @Input({ required: true }) reportName: string;
    @Input({ required: true }) set options(value: VisualizationOptionsType) {
        this.optionsSignal.set(value);
    }
    get options() {
        return this.optionsSignal();
    }
    readonly optionsSignal = signal<VisualizationOptionsType>(null);
    @Input() company: CompanyEntity;

    private readonly deviceService = inject(DeviceService);
    private readonly datePeriodService = inject(DatePeriodService);
    private readonly route = inject(ActivatedRoute);

    public isMobile = this.deviceService.getIsMobile();
    public linkDigital: string = "";

    ngOnInit(): void {
        const { companyId, reportId } = this.route.snapshot.queryParams;
        this.linkDigital = `${environment.BASEURL}/dashboard?companyId=${companyId}&reportId=${reportId}&liveToken=${environment.LIVE_TOKEN}`;
    }

    public readonly dateLabel = computed((): string => {
        if (!this.options) return "";
        return this.datePeriodService.getDateLabel(this.options);
    });
}
